module.exports = __webpack_public_path__ + "assets/fonts/iconfont.d7665243.ttf";